export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L0_solid_m_01_f_mask.f3eecb7d.png";